import React from 'react';

const SetQuick = () => {
    return (
        <svg width={11} height={12.111} viewBox="0 0 11 12.111">
            <path
                d="M6.056.5L.5 7.167h5l-.556 4.444L10.5 4.944h-5z"
                fill="none"
                stroke="#000946"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default SetQuick;
